const revealTransitionDurationMs = 475;
const badge = "_35sbrtlq3r";
const hint = "_35sh16zsix7";
const label = "_35sl1u1rvit";
const text = "_35stcql86t";

export { badge, hint, label, revealTransitionDurationMs, text };
import "./atom.hint.style.linaria.module.css";
//# sourceMappingURL=atom.hint.style.js.map
